// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"47823f97d47a676c","531":"e5a505596709a620","777":"64a07b4817f0eaf2","934":"7b2c22eaecd941dc"}[chunkId] + ".js";
};